import { Column, Entity, Index } from 'typeorm';
import type { TemplateVariableDefinition } from '../../types/template-variable.types';
import { BaseEntity } from './base.entity';

@Entity('_messaging_template')
export class MessagingTemplateEntity extends BaseEntity {
	@Column({ type: 'varchar', length: 255, unique: true })
	public name!: string;

	@Column({ type: 'text', nullable: true })
	public description?: string;

	@Column({ type: 'text' })
	public template!: string;

	@Column({ type: 'json', nullable: true })
	public variables?: Array<TemplateVariableDefinition>;

	@Column({ name: 'is_active', type: 'boolean', default: true })
	@Index()
	public isActive!: boolean;

	@Column({ type: 'json', nullable: true })
	public metadata?: Record<string, unknown>;

	@Column({ type: 'varchar', length: 100, unique: true, nullable: true })
	public systemSlug?: string;
}
